<template>
  <div class="report-section report-section-suggest-overview">
    <div v-if="reportData.options?.name || reportData.name" class="section-title">{{ reportData.options?.name || reportData.name }}</div>
    <div v-if="reportData.options?.description || reportData.description" class="section-description">{{ reportData.options?.description || reportData.description }}</div>
    <overview-index
      ref="template"
      :is-template="true"
      :template-params="reportData.queryParams || reportData.options?.queryParams"
      :is-template-edit="isTemplateEdit"
      :default-project-id="isTemplateEdit ? '' : scopeParams.project_id || ''"
      :default-domain-id="isTemplateEdit ? '' : scopeParams.domain_id || ''" />
  </div>
</template>

<script>
import OverviewIndex from '@Subscription/views/suggestsOverview/index.vue'

export default {
  name: 'ReportSuggestOverview',
  components: {
    OverviewIndex,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    isTemplateEdit: {
      type: Boolean,
      default: false,
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
    reportType: {
      type: String,
    },
  },
  methods: {
    getTemplateParams () {
      return this.$refs.template.getTemplateParams()
    },
  },
}
</script>

<style lang="less" scoped>
.report-section-suggest-overview {
  max-width: 695px;
}
.section-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 15px;
}
.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
